/**
 * The name shown for the provider that ran a Confirmation of Payee check.
 *
 * Mapped explicitly rather than as a two-way ternary: the backend records
 * `gocardless-sandbox` for a check answered by GoCardless's sandbox, and a
 * ternary on `gocardless` rendered that as "Creditsafe" — naming the wrong
 * vendor and hiding that the result was fabricated. An unknown value is shown
 * as it is rather than guessed.
 *
 * @param {string | null | undefined} provider `cop_check_provider` from the application.
 * @returns {string}
 */
export function copProviderLabel(provider) {
  const labels = {
    gocardless: "GoCardless",
    "gocardless-sandbox": "GoCardless SANDBOX",
    creditsafe: "Creditsafe",
  };
  if (!provider) return "Creditsafe";
  return labels[provider] ?? provider;
}
